import type { BankingProduct } from '@models/loyalty-libs';

import { createReducer, on } from '@ngrx/store';
import { deleteBankingProductSuccess, setBankingProductList } from '@stores/banking-products/banking-product.actions';

export const bankingProductFeatureKey = 'bankingProduct';

export type BankingProductState = BankingProduct[];

const initialState: BankingProductState = [];

export const bankingProductReducer = createReducer(
  initialState,

  on(setBankingProductList, (_, { bankingProducts }) => bankingProducts),

  on(deleteBankingProductSuccess, (state, { bankingProductId }) =>
    state.filter((bankingProduct) => bankingProduct.id !== bankingProductId)
  )
);
